import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { useContext, useEffect, useState } from 'react';

import CanonicalURL from '@/components/common/Canonical';
import { getSEOProps } from '@/components/utility';
import HeaderFooterContext from '@/context/HeaderFooterContext';
import { getArticles } from '@/services/blogs';
import { getInnerPagesWithDefaultLocale } from '@/services/home';
import SetBrandsContext from '@/services/home/setBrands';
import { parqApiForPrice } from '@/services/portable-storage';
import {
  BRAND_NAME_EN,
  BRAND_NAME_FR,
  PORTABLE_BUSINESS,
  PORTABLE_BUSINESS_FR,
} from '@/utils/constants';
import defaultCenters from '@/utils/default';

const PortableBusinessComponent = dynamic(
  () => import('@/components/portable-business')
);
const StorageHowTo = dynamic(
  () => import('@/components/self-storage-moving/storage-how-to')
);

const BusinessStorage = (props: any) => {
  const portResData = props?.portResData;
  const [priceValue, setPriceValue] = useState();
  const articlesData = props?.articlesData;
  const headerFooterData = useContext(HeaderFooterContext);
  const { headerFooter } = headerFooterData;
  const router = useRouter();
  const seoProps = getSEOProps(portResData?.attributes?.SEO, router);
  const { locale }: any = useRouter();

  const isContext = !!headerFooter[0];

  const getContextData = async () => {
    let defaultBrand = BRAND_NAME_EN;
    if (locale === 'fr') defaultBrand = BRAND_NAME_FR;
    const contextData = await SetBrandsContext(defaultBrand, locale);
    const brands = contextData?.data;
    headerFooterData.setHeaderFooterData(brands);
  };
  useEffect(() => {
    getContextData();
    if (sessionStorage.getItem('blogCords')) {
      sessionStorage.removeItem('blogCords');
    }
  }, [isContext, locale]);
  const getPriceData = async (latitude: any, longitude: any) => {
    const priceRes = await parqApiForPrice(latitude, longitude);

    setPriceValue(priceRes?.data?.price);
  };
  useEffect(() => {
    // Naviagtor function handles success call back for allow and block for reject call back.
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        getPriceData(latitude, longitude);
      },
      () => {
        const latitude = defaultCenters[0].center.lat;
        const longitude = defaultCenters[0].center.lng;
        getPriceData(latitude, longitude);
      }
    );
  }, [locale]);
  return (
    <>
      <NextSeo {...seoProps} />
      <CanonicalURL />
      <PortableBusinessComponent
        portResData={portResData}
        priceValue={priceValue}
      />
      <StorageHowTo articlesData={articlesData}></StorageHowTo>
    </>
  );
};

export async function getServerSideProps(props: any) {
  const locale = props?.locale;
  let defaultBrand = BRAND_NAME_EN;
  let defaultLink = PORTABLE_BUSINESS;
  let category = 'moving';
  const pageSize = 3;
  if (locale === 'fr') {
    defaultLink = PORTABLE_BUSINESS_FR;
    defaultBrand = BRAND_NAME_FR;
    category = 'moving-fr';
  }

  const portResRes = await getInnerPagesWithDefaultLocale(
    defaultLink,
    defaultBrand,
    locale
  );

  const portResData = (await portResRes?.data?.data[0]) || null;

  const articlesRes = await getArticles(
    defaultBrand,
    pageSize,
    locale,
    category
  );

  const articlesData = await articlesRes?.data;

  return {
    props: {
      portResData,
      articlesData,
    },
  };
}

export default BusinessStorage;
